// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__r0-zs","label":"Radio_label__36UnI","checkMark":"Radio_checkMark__250co","disabled":"Radio_disabled__9msKk"};